import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Icon } from '@mui/material';
import { useIsAuthenticated } from '@azure/msal-react';

const PageNotFound: React.FC = () => {
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();

  const onClickNavigate = (path: string) => {
    if (path.startsWith('http')) {
      window.open(path, '_blank', 'noopener,noreferrer');
    }
    else {
      navigate(path);
    }
  };
  
  return (
    <>
      <header className="page-header container">
        <h1>U bent buiten uw werkgebied beland!</h1>
        <p className="header-sub-title">
          Dit onderdeel van infraplannen is hier niet beschikbaar. Misschien is de route onjuist, bestaat het plan of afstemmingsdossier niet of maakt het geen deel uit van uw werkgebied. 
          Controleer de link of navigeer via het overzicht om uw werkzaamheden te hervatten binnen uw werkgebied.
        </p>
      </header>

      <div className="page-content container content content-not-found">
        <div className="btn-group">
          {isAuthenticated && (
            <>
              <Button variant="contained" color="secondary" onClick={() => onClickNavigate('/dossiers')}>
                Naar de afstemmingsdossiers
                <Icon>chevron_right</Icon>
              </Button>
              <Button variant="text" color="secondary" onClick={ () => onClickNavigate('/plannen') }>
                Naar de plannen
                <Icon>chevron_right</Icon>
              </Button>

              <Button variant="text" color="secondary" onClick={ () => onClickNavigate('https://mijnaansluiting.atlassian.net/wiki/spaces/Wiki/pages/628588545/Gebruikershandleiding+infraplannen.nl') }>
                Lees de handleiding
                <Icon>chevron_right</Icon>
              </Button>
              <Button variant="text" color="secondary" onClick={ () => onClickNavigate('/contact') }>
                Contact opnemen
                <Icon>chevron_right</Icon>
              </Button>
            </>
          )}

          {!isAuthenticated && (
            <>
              <Button variant="contained" color="secondary" onClick={() => onClickNavigate('/')}>
                Naar startpagina
                <Icon>chevron_right</Icon>
              </Button>

              <Button variant="text" color="secondary" onClick={ () => onClickNavigate('https://mijnaansluiting.atlassian.net/wiki/spaces/Wiki/pages/628588545/Gebruikershandleiding+infraplannen.nl') }>
                Lees de handleiding
                <Icon>chevron_right</Icon>
              </Button>
              <Button variant="text" color="secondary" onClick={ () => onClickNavigate('/contact') }>
                Contact opnemen
                <Icon>chevron_right</Icon>
              </Button>
            </>
          )}
        </div>

        <div className="image-layout layout-not-found">
          <img src={require('../../../assets/images/page_headers/img_niet_gevonden.jpg')} alt="404 Error - U bent buiten uw werkgebied beland!" />
        </div>  
      </div>
    </>
  );
};

export default PageNotFound;